/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class SystemActionWorkflowBlock extends MultipleOutputWorkflowBlock {

        public systemActionDto: Wars.Domain.Model.Dtos.Workflow.SystemActionDto;

        constructor(id: string, label: string) {
            super(id, Wars.Domain.Model.Codes.Enums.BlockType.SystemAction, label);

            this.svgScale = 0.75;
            this.svgToolbarScale = 0.4;
            this.svgWidth = 95.45;
            this.svgHeight = 99.95;

            this.svgUrl = "./Content/Images/WorkflowShapes/SystemAction.svg";
            this.svgAttributes = { id: this.id, "data-class": "workflowBlock", "data-id": "systemAction" };
        }

        public populateDto(dto: Wars.Domain.Model.Dtos.Workflow.SystemActionDto) {
            this.systemActionDto = dto;
        }
    }
}